import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { ClerkProvider } from '@clerk/react'
import { MantineProvider } from '@mantine/core'
import { ModalsProvider } from '@mantine/modals'
import { Notifications } from '@mantine/notifications'
import { ApiProvider } from './api/ApiProvider.jsx'
import { SessionProvider, SessionRealtimeBridge } from './api/SessionProvider.jsx'
import { RealtimeProvider } from './api/RealtimeProvider.jsx'
import ReferralAttach from './components/referral/ReferralAttach.jsx'
import { captureReferralCode } from './referral.js'
import { store } from './store/store.js'
import Router from './Router.jsx'
import './index.css'
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

// Capture ?ref=<code> before the first render (contract §4.22) — the visitor
// is typically anonymous here and about to lose the query string to routing
// and the Clerk sign-up redirects.
captureReferralCode()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      <MantineProvider defaultColorScheme="light" primaryColor="pink">
        <ModalsProvider>
          <ApiProvider>
            <SessionProvider>
              <RealtimeProvider>
                <SessionRealtimeBridge />
                <ReferralAttach />
                <Provider store={store}>
                  <Notifications />
                  <Router />
                </Provider>
              </RealtimeProvider>
            </SessionProvider>
          </ApiProvider>
        </ModalsProvider>
      </MantineProvider>
    </ClerkProvider>
  </StrictMode>,
)
